// 價格表與匯率一律取自 src/shared/model-pricing.ts。
// 本檔原本自帶一份，且匯率誤為 32（後端計費用 33），造成同一筆紀錄
// 在扣點與後台顯示上金額不一致。
import { MODEL_PRICING, USD_TO_TWD, type ModelPricing } from '../../shared/model-pricing';

export function calcCostTWD(modelName: string, inputTokens: number, outputTokens: number, thoughtTokens: number): string | null {
  const pricing: ModelPricing | undefined = MODEL_PRICING[modelName];
  if (!pricing) return null;
  const usd =
    (pricing.inputUsdPerMillion / 1_000_000) * inputTokens +
    (pricing.outputUsdPerMillion / 1_000_000) * outputTokens +
    (pricing.thoughtUsdPerMillion / 1_000_000) * thoughtTokens;
  const twd = usd * USD_TO_TWD;
  if (twd < 0.001) return '< NT$0.001';
  return `NT$${twd.toFixed(4)}`;
}

/** Returns total cost in TWD as a number, or null if any call has unknown pricing. */
export function sumCostTWD(logs: { modelName: string; inputTokens: number; outputTokens: number; thoughtTokens: number }[]): number | null {
  let total = 0;
  for (const log of logs) {
    const pricing: ModelPricing | undefined = MODEL_PRICING[log.modelName];
    if (!pricing) return null;
    const usd =
      (pricing.inputUsdPerMillion / 1_000_000) * log.inputTokens +
      (pricing.outputUsdPerMillion / 1_000_000) * log.outputTokens +
      (pricing.thoughtUsdPerMillion / 1_000_000) * log.thoughtTokens;
    total += usd * USD_TO_TWD;
  }
  if (total < 0.001) return 0;
  return total;
}

export function formatCostTWD(value: number | null): string {
  if (value === null) return '—';
  if (value === 0) return '< NT$0.001';
  return `NT$${value.toFixed(4)}`;
}
